import { z } from 'zod';

import { ComponentPayloadValidator, ComponentValidator } from '../Component';

import { ComponentDefinition } from '../../types/ComponentDefinition';

const ControllerBase = z.object({
    type: z.literal('controller').default('controller'),
    electrical: z
        .object({
            ports: z.array(z.any()).max(0).default([]),
        })
        .default({}),
});

export const ControllerValidator = ComponentValidator.merge(ControllerBase);
export const ControllerPayloadValidator = ComponentPayloadValidator.merge(ControllerBase);

export const ControllerDefinition: ComponentDefinition = {
    type: 'controller',
    name: 'Controller',
    plural: 'Controllers',
    indicator: 'CTRL',
    hasDynamicNumberOfPorts: false,
    interoperabilityDataModel: false,
    ports: {
        min: 0,
        max: 0,
        powerFlowDirections: [],
    },
    actsAsConverter: false,
    actsAsBus: false,
    liveData: {
        enabled: true,
        showGraphs: true,
    },
    validators: {
        component: ControllerValidator,
        payload: ControllerPayloadValidator,
    },
};

export type Controller = z.infer<typeof ControllerValidator>;
export type ControllerPayload = z.infer<typeof ControllerPayloadValidator>;
